import {domain} from '../config/auth';

// ── AI Chatbot ───────────────────────────────────────────────────────────────
// Required by src/api/chatbot.js — removing any of these breaks the build.
export const CHAT_MESSAGE = domain + '/api/chat';
export const CHAT_APPLY_PROFILE_UPDATE = domain + '/api/chat/apply-profile-update';
export const CHAT_FEEDBACK = domain + '/api/chat/feedback';
export const CHAT_MY_SESSION = domain + '/api/chat/my-session';
export const CHAT_UPLOAD_RESUME = domain + '/api/chat/upload-resume';
export const CHAT_APPLY_PROFILE_ADD = domain + '/api/chat/apply-profile-add';
export const CHAT_START_REGISTRATION_FORM = domain + '/api/chat/start-registration-form';
export const CHAT_VERIFY_REGISTRATION_FORM_OTP = domain + '/api/chat/verify-registration-form-otp';
export const CHAT_LOGIN_FORM = domain + '/api/chat/login-form';
export const CHAT_VERIFY_LOGIN_FORM_OTP = domain + '/api/chat/verify-login-form-otp';

// Public — reads an uploaded CV and returns name/email/phone for the signup
// form. No account required; rate limited by IP on the server.
export const RESUME_PREFILL = domain + '/api/resume/prefill';
// DELETE — unlinks the CV from the profile; the stored file is left alone.
export const REMOVE_RESUME = domain + '/api/candidate/resume';
export const RESEND_OTP =  domain  + '/api/auth/resend-otp';
export const FORGOT_PASSWORD =  domain  + '/api/auth/forgot-password';
export const RESET_PASSWORD =  domain  + '/api/auth/reset-password';
export const ADD_CLIENT = domain + '/api/add_client';
export const GET_CLIENT_LIST =  domain + '/api/admin/companies';
export const UPDATE_CLIENT = domain + '/api/update_client';
export const ADD_RECRUITER = domain + '/api/add/recruiter';
export const GET_RECRUITER_LIST = domain + '/api/recruiter/{id}';
export const UPDATE_RECRUITER = domain + '/api/recruiters/update';
export const DELETE_RECRUITER = domain + '/api/admin/recruiters';
export const GET_ALL_CANDIDATES = domain + '/api/admin/candidates';
export const ADMIN_JOBSEEKER_ACTIVITY_REPORT = domain + '/api/admin/reports/jobseeker-activity';
export const ADMIN_REGISTRATIONS_REPORT = domain + '/api/admin/reports/registrations';
export const ADMIN_APPLICATIONS_REPORT = domain + '/api/admin/reports/applications';
export const ADMIN_REFERRALS_REPORT = domain + '/api/admin/reports/referrals';
export const ADMIN_REFERRALS_SUMMARY_REPORT = domain + '/api/admin/reports/referrals/summary';
// Admin → Reports → Resume Views: who opened which CV (first open per viewer + candidate).
export const ADMIN_RESUME_VIEWS_REPORT = domain + '/api/admin/reports/resume-views';
export const ADMIN_RESUME_VIEWS_SUMMARY_REPORT = domain + '/api/admin/reports/resume-views/summary';
// Admin → Reports → Email Summary: applications + emails to candidates / schools / admins (?from&to).
export const ADMIN_EMAIL_SUMMARY_REPORT = domain + '/api/admin/reports/email-summary';
// The lists behind its tiles: ?group=candidate|school|admin|other|all|failed (group=school also takes
// ?phone=with|without and ?view=schools for one row per school), and ?view=applications|people.
export const ADMIN_EMAIL_SUMMARY_EMAILS = domain + '/api/admin/reports/email-summary/emails';
export const ADMIN_EMAIL_SUMMARY_APPLICATIONS = domain + '/api/admin/reports/email-summary/applications';
// Admin → Reports → School Usage: one row per school (?view=at-risk&bucket&sort), and one school's jobs (?companyId).
export const ADMIN_SCHOOL_USAGE_REPORT = domain + '/api/admin/reports/school-usage';
export const ADMIN_SCHOOL_USAGE_JOBS_REPORT = domain + '/api/admin/reports/school-usage/jobs';
// POST { candidateId, jobId?, applicationId?, source } — logged on every Resume button.
export const RESUME_VIEW_LOG = domain + '/api/resume-views';
// Admin → Reports → Newspaper AI (API: modules/newspaper/reportsController.js). Same from/to/search/page/limit as the others, plus ?flag= (and ?kind= on designations).
export const ADMIN_NEWSPAPER_JOBS_REPORT = domain + '/api/admin/reports/newspaper/jobs';
export const ADMIN_NEWSPAPER_SCHOOLS_REPORT = domain + '/api/admin/reports/newspaper/schools';
export const ADMIN_NEWSPAPER_DESIGNATIONS_REPORT = domain + '/api/admin/reports/newspaper/designations';
export const ADMIN_NEWSPAPER_ANALYSIS_REPORT = domain + '/api/admin/reports/newspaper/analysis';
export const GET_HERO_BANNERS = domain + '/api/hero-banners';
export const ADMIN_HERO_BANNER = domain + '/api/admin/hero-banner';
// Admin list (includes Inactive) on GET, batch sequence/status save on PUT.
export const ADMIN_HERO_BANNERS = domain + '/api/admin/hero-banners';
export const UPDATE_CANDIDATE_STATUS = domain + '/api/admin/update/candidates/status';
export const RESET_TEMP_FLAG = domain + '/api/reset-temp-flag';
export const CHANGE_PASSWORD =  domain  + '/api/auth/change-password';

export const ADD_JOB = domain + '/api/add/job';
export const GET_ADMIN_JOB_LIST = domain + '/api/admin/jobs';
// Stores a school or brand logo and returns its path; the calling form then
// sends that path with its own save. See admin.controller.uploadLogo.
export const ADMIN_UPLOAD_LOGO = domain + '/api/admin/logo';
export const ADMIN_CREATE_JOB = domain + '/api/admin/create-job';
export const UPDATE_JOB = domain + '/api/update/job';
// A function because the id is in the PATH, not the body — the one job
// endpoint that is REST-shaped rather than a POST with an id inside.
export const DELETE_JOB = (id) => domain + '/api/jobs/' + id;
export const GET_JOB_LIST =  domain + '/api/jobs';
export const JOB_APPLY = domain + '/api/application/apply';
export const GET_JOB_DETAILS = domain + '/api/jobById';
export const GET_CANDIDATE_APPLICATION = domain + '/api/applications/job';
export const GET_ADMIN_CANDIDATE_APPLICATION = domain + '/api/admin/applications/job';
// Interview schedule on an application selected for interview (recruiter + admin).
// POST { id, interviewAt (ISO), durationMins, mode, location, note, sendEmail } / { id, sendEmail }
export const INTERVIEW_SCHEDULE = domain + '/api/applications/interview/schedule';
export const INTERVIEW_CANCEL = domain + '/api/applications/interview/cancel';
export const UPDATE_APPLICATION_STATUS = domain + '/api/applications/status';
export const GET_ALL_APPLICATION = domain + '/api/applications/candidate';

export const UPDATE_PROFILE = domain + '/api/candidate/update-profile';
export const UPDATE_CAREER_PROFILE = domain + '/api/candidate/career-profile';
export const UPDATE_PROFILE_SUMMARY = domain + '/api/candidate/update-profile-summary';
export const GET_CANDIDATE_PROFILE = domain + '/api/candidate/profile';
export const GET_SKILLS = domain + '/api/skills';
export const ADD_SKILLS = domain + '/api/candidate/add/skills';
export const UPDATE_PERSONAL_DETAILS = domain + '/api/candidate/update-personal-details';
export const VERIFY_PINCODE = domain + '/api/candidate/verify-pincode';
export const ADD_EDUCATION = domain + '/api/candidate/add/education';
export const UPDATE_EDUCATION = domain + '/api/candidate/update/education';
export const DELETE_EDUCATION  = domain + '/api/candidate/delete/education';
export const ADD_EMPLOYMENT = domain + '/api/candidate/add/experience';
export const UPDATE_EMPLOYMENT = domain + '/api/candidate/update/experience';
export const DELETE_EMPLOYMENT = domain + '/api/candidate/delete/experience';
export const ADD_PROJECT = domain + '/api/candidate/add/project';
export const UPDATE_PROJECT = domain + '/api/candidate/update/project';
export const DELETE_PROJECT = domain + '/api/candidate/delete/project';
export const ADD_CERTIFICATE = domain + '/api/candidate/add/certificate';
export const UPDATE_CERTIFICATE = domain + '/api/candidate/update/certificate';
export const DELETE_CERTIFICATE = domain + '/api/candidate/delete/certificate';

// Resume Builder APIs
export const GET_RESUME_DATA = domain + '/api/candidate/resume/data';
export const GENERATE_RESUME_SUMMARY = domain + '/api/candidate/resume/summary';
export const DOWNLOAD_RESUME = domain + '/api/candidate/resume/download';

// Document Management APIs
export const UPLOAD_DOCUMENT = domain + '/api/documents/upload';
export const LIST_DOCUMENTS = domain + '/api/documents/list';
export const DELETE_DOCUMENT = domain + '/api/documents/delete';

export const GET_FEATURED_COMPANIES = domain + '/api/candidate/featured/companies';

// Categories
export const GET_DEPARTMENTS = domain + '/api/departments';
export const GET_CATEGORIES = domain + '/api/categories';
export const GET_SUB_CATEGORIES = domain + '/api/subcategories';
export const GET_CATEGORIES_WITH_COUNT = domain + '/api/categories/with-count';

// Jobs mega-menu highlights (locations + in-demand titles from the jobs table)
export const GET_JOB_HIGHLIGHTS = domain + '/api/jobs/highlights';

// Recruiter stats
export const GET_RECRUITER_DASHBOARD_STATS = domain + '/api/recruiter/dashboard';

// ── Communication – Email Template ──────────────────────────────────────────
export const GET_EMAIL_TEMPLATES      = domain + '/api/admin/email-templates';    // GET
export const GET_EMAIL_TEMPLATE_BY_ID = domain + '/api/admin/email-templates';    // GET  /:id appended at call site
export const CREATE_EMAIL_TEMPLATE    = domain + '/api/admin/email-templates';    // POST
export const UPDATE_EMAIL_TEMPLATE    = domain + '/api/admin/email-templates';    // PUT  /:id appended at call site
export const SEND_EMAIL_TEMPLATE_TEST = domain + '/api/admin/email-templates/test-send';

// ── Communication – Schedule ─────────────────────────────────────────────────
export const GET_SCHEDULES         = domain + '/api/admin/communication-schedules';   // GET
export const GET_SCHEDULE_BY_ID    = domain + '/api/admin/communication-schedules';   // GET  /:id appended
export const CREATE_SCHEDULE       = domain + '/api/admin/communication-schedules';   // POST
export const UPDATE_SCHEDULE       = domain + '/api/admin/communication-schedules';   // PUT  /:id appended
export const SEND_SCHEDULE_TEST    = domain + '/api/admin/communication-schedules/test-send';
export const GET_USER_EMAILS       = domain + '/api/admin/users/emails';              // GET  – for "To" dropdown

// ── Recruiter – Candidates ───────────────────────────────────────────────────
export const RECRUITER_SEARCH_CANDIDATES = domain + '/api/recruiter/candidates/search'; // POST
export const RECRUITER_CANDIDATE_RESUME  = domain + '/api/recruiter/candidates';        // GET  /:id/resume appended at call site

// ── Analytics ────────────────────────────────────────────────────────────────
export const TRACK_VISIT             = domain + '/api/analytics/track';
export const GET_ANALYTICS_DASHBOARD = domain + '/api/admin/analytics/dashboard';

// ── Consent provenance ───────────────────────────────────────────────────────
// Both live under /api/admin/dashboard/, so utils/api.js leaves their 401s to
// the component rather than bouncing to /login. Unlike the rest of that prefix
// these two check the caller's role, so a non-admin gets 403, not data.
export const GET_CONSENT_OVERVIEW = domain + '/api/admin/dashboard/consent';
export const GET_CONSENT_PENDING  = domain + '/api/admin/dashboard/consent/pending';

// ── Notifications ─────────────────────────────────────────────────────────────
export const GET_NOTIFICATIONS          = domain + '/api/communication/notifications';
export const GET_UNREAD_NOTIF_COUNT     = domain + '/api/communication/notifications/unread-count';
export const MARK_NOTIFICATION_READ     = domain + '/api/communication/notifications';  // + /:id/read  (PUT)
export const MARK_ALL_NOTIFICATIONS_READ = domain + '/api/communication/notifications/read-all';

// ── Consent ───────────────────────────────────────────────────────────────────
export const GET_CONSENT_STATUS         = domain + '/api/me/consent-status';  // GET
export const GRANT_CONSENT              = domain + '/api/me/consent';         // POST { accepted: true }

/* ── Account states ───────────────────────────────────────────────────────────
 *
 * Three states an account can be taken out of service in — paused (inactive),
 * suspended (blocked) and closed (blacklisted) — plus the job-seeker's own
 * controls. See the API's utils/accountState.js for what each one means.
 */
// Admin. POST { userId | companyId, state, reason } — one route for all three
// states and for restoring, including a school and every account under it.
export const SET_ACCOUNT_STATE          = domain + '/api/admin/account-state';
export const ACCOUNT_STATE_HISTORY      = domain + '/api/admin/account-state/history'; // GET ?userId= | ?companyId=

// The member's own account.
export const MY_ACCOUNT_STATE           = domain + '/api/me/account-state';              // GET
export const DEACTIVATE_MY_ACCOUNT      = domain + '/api/me/account-state/deactivate';   // POST
export const REACTIVATE_MY_ACCOUNT      = domain + '/api/me/account-state/reactivate';   // POST

/*
 * Schools a job-seeker has hidden. Called "hidden", never "blocked", in
 * everything the seeker sees: an admin block is a sanction on an account, this
 * is a private preference that changes nothing for the school.
 */
export const HIDDEN_SCHOOLS             = domain + '/api/me/hidden-schools'; // GET, POST { companyId }, DELETE /:companyId
export const ME_SCHOOLS                 = domain + '/api/me/schools';         // GET: every school + hidden flag for this seeker
/*
 * The school directory: schools NOT on Talexo (the UDISE+ register), which a
 * seeker can hide ahead of the day they join. Server-side search and paging —
 * it holds thousands of rows where ME_SCHOOLS holds dozens.
 */
export const ME_DIRECTORY_SCHOOLS       = domain + '/api/me/directory-schools';        // GET ?search&page&limit[&show=hidden]
export const HIDDEN_DIRECTORY_SCHOOLS   = domain + '/api/me/hidden-directory-schools'; // POST { directorySchoolId }, DELETE /:id
export const ADMIN_DIRECTORY_SCHOOLS    = domain + '/api/admin/directory-schools';     // GET ?search&limit (admin UDISE picker)
export const ADMIN_COMPANY_UDISE        = (companyId) => `${domain}/api/admin/companies/${companyId}/udise`; // PUT { udiseCode | null }

/* ── Institutes (the school-brand master) ─────────────────────────────────────
 *
 * A brand that several campuses share. Admin-only, all of it — restricting
 * creation to admins is one of the three defences that stop the master filling
 * up with "DPS", "D.P.S" and "Delhi Public School" as three separate brands.
 *
 * LOOKUP is the type-ahead behind the Add Client form, and it is READ-ONLY on
 * purpose: the client form searches brands, it never creates one. That is the
 * third defence, and adding a create-from-the-client-form call here would undo
 * it.
 *
 * The institute is identity only. It has no plan, no contract and no status
 * that gates access — everything that means "the customer" still goes through
 * the client (companies) endpoints above.
 */
export const ADMIN_INSTITUTES        = domain + '/api/admin/institutes';         // GET (list), POST (create)
export const ADMIN_INSTITUTE         = domain + '/api/admin/institutes';         // + /:id  — GET, PUT, DELETE
export const ADMIN_INSTITUTE_LOOKUP  = domain + '/api/admin/institutes/lookup';  // GET ?q= — the type-ahead

// School boards (CBSE, ICSE, ...). BOARDS = active only, public; ADMIN_BOARDS = all, + /:id for PUT.
export const BOARDS                  = domain + '/api/boards';
export const ADMIN_BOARDS            = domain + '/api/admin/boards';
// GET ?name=&city= — "which group does this school belong to?", asked on save
export const SUGGEST_INSTITUTES      = domain + '/api/admin/institutes/suggest';

// Admin → Newspaper Extraction (API: modules/newspaper). Admin-only.
export const ADMIN_NEWSPAPER_PAGES        = domain + '/api/admin/newspaper/pages';        // GET list, POST upload (multipart `image`); + '/:id', '/:id/retry', '/:id/image'
export const ADMIN_NEWSPAPER_ADS          = domain + '/api/admin/newspaper/ads';          // + '/:adId/crop', '/:adId/duplicates', '/:adId/post'
export const ADMIN_NEWSPAPER_POSITIONS    = domain + '/api/admin/newspaper/positions';    // + '/:id/discard', '/:id/restore'
export const ADMIN_NEWSPAPER_SCHOOLS      = domain + '/api/admin/newspaper/schools';      // GET ?q=
export const ADMIN_NEWSPAPER_DESIGNATIONS = domain + '/api/admin/newspaper/designations'; // GET list, POST create
export const ADMIN_NEWSPAPER_CAPTURES     = domain + '/api/admin/newspaper/captures';     // POST { date, pageNumber?, location?, edition? } — live capture from HT
export const ADMIN_NEWSPAPER_EDITIONS     = domain + '/api/admin/newspaper/editions';     // GET — HT e-paper locations and their editions
export const ADMIN_NEWSPAPER_AGENT        = domain + '/api/admin/newspaper/agent';        // GET — is the capture PC connected?
export const ADMIN_NEWSPAPER_HT_LOGIN     = domain + '/api/admin/newspaper/ht-login';     // GET status, POST start; + '/otp' { otp }, '/cancel'
